import {Link, Route, Routes} from "react-router-dom";
import React, {useState} from "react";
import './Navbar.css';
import Startseite from "../Startseite";
import Ab10m from "../pages/Ab10m";
import AB10mk from "../pages/AB10mk";
import Ab30m from "../pages/Ab30m";
import Verwaltung from "../pages/Verwaltung";
import Login from "../Login";
import Ab10ma from "../pages/Ab10ma";
import Stammdaten from "../pages/Stammdaten";
import Saisondaten from "./Saisondaten";
import VerwaltungWettkampf from "../pages/VerwaltungWettkampf";
import Ergebnisse from "./Ergebnisse";
import Mannschaftsmeldung from "../pages/Mannschaftsmeldung";
import Ab10mSetzliste from "../pages/Ab10mSetzliste";
import Ab10mEinzelwertung from "../pages/Ab10mEinzelwertung";
import Bau from "../pages/bau";
import Ab10mkEinzelwertung from "../pages/Ab10mkEinzelwertung";
import Ab10mAEinzelwertung from "../pages/Ab10mAEinzelwertung";
import Ab30mEinzelwertung from "../pages/Ab30mEinzelwertung";
import Ab10mASetzliste from "../pages/Ab10mASetzliste";
import Ab10mkSetzliste from "../pages/Ab10mkSetzliste";
import Ab30mSetzliste from "../pages/Ab30mSetzliste";
import EigenerUser from "../pages/EigenerUser";

export function Navbar(props) {
    const [menuOpen, setMenuOpen] = useState(false);
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    const closeMenu = () => {
        setMenuOpen(false);
    };

    return <main>
        <nav className="navbar">
            <div className="navbar-header">
                <button className={menuOpen ? "hamburger-menu active" : "hamburger-menu"} onClick={toggleMenu} aria-label="Menu">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
            <ul className={menuOpen ? "nav-menu active" : "nav-menu"}>
                <li><Link to="/Startseite" onClick={closeMenu}>Startseite</Link></li>
                <li className="dropdown">
                    <Link to="/Ab10m" onClick={closeMenu}>Armbrust 10m</Link>
                    <ul className="dropdown-menu">
                        <li><Link to="SetzlistenAB10m" onClick={closeMenu}>Setzlisten</Link></li>
                        <li><Link to="EinzelwertungAB10m" onClick={closeMenu}>Einzelwertung</Link></li>
                    </ul>
                </li>
                <li className="dropdown">
                    <Link to="/AB10mk" onClick={closeMenu}>Armbrust 10m kniend</Link>
                    <ul className="dropdown-menu">
                        <li><Link to="SetzlistenAB10mk" onClick={closeMenu}>Setzlisten</Link></li>
                        <li><Link to="EinzelwertungAB10mk" onClick={closeMenu}>Einzelwertung</Link></li>
                    </ul>
                </li>
                <li className="dropdown">
                    <Link to="/Ab10ma" onClick={closeMenu}>Armbrust 10m Auflage</Link>
                    <ul className="dropdown-menu">
                        <li><Link to="SetzlistenAB10ma" onClick={closeMenu}>Setzlisten</Link></li>
                        <li><Link to="EinzelwertungAB10ma" onClick={closeMenu}>Einzelwertung</Link></li>
                    </ul>
                </li>
                <li className="dropdown">
                    <Link to="/Ab30m" onClick={closeMenu}>Armbrust 30m</Link>
                    <ul className="dropdown-menu">
                        <li><Link to="SetzlistenAB30m" onClick={closeMenu}>Setzlisten</Link></li>
                        <li><Link to="EinzelwertungAB30m" onClick={closeMenu}>Einzelwertung</Link></li>
                    </ul>
                </li>
                {props.loggedIn && (
                    <li className="dropdown">
                        <Link to="/Verwaltung" onClick={closeMenu}>Verwaltung</Link>
                        <ul className="dropdown-menu">
                            <li><Link to="/Verwaltung/Stammdaten" onClick={closeMenu}>Stammdaten</Link></li>
                            <li><Link to="/Verwaltung/Saisondaten" onClick={closeMenu}>Saisondaten</Link></li>
                            <li><Link to="/Verwaltung/Wettkampf" onClick={closeMenu}>Wettkämpfe</Link></li>
                        </ul>
                    </li>
                )}
                {props.loggedIn && (
                    <li className="dropdown">
                        <Link to="/Konfiguration" onClick={closeMenu}>Konfiguration</Link>
                        <ul className="dropdown-menu">
                            <li><Link to="/Konfiguration/Ergebnisse" onClick={closeMenu}>Ergebnisse</Link></li>
                            <li><Link to="/Konfiguration/Mannschaftsmeldung" onClick={closeMenu}>Mannschaftsmeldung</Link></li>
                            <li><Link to="/Konfiguration/EigenerUser" onClick={closeMenu}>Eigener User</Link></li>
                        </ul>
                    </li>
                )}
            </ul>
        </nav>
        <Routes>
            <Route path="/Startseite" element={<Startseite/>}/>
            <Route path="/Ab10m" element={<Ab10m/>}/>
            <Route path="SetzlistenAB10m" element={<Ab10mSetzliste/>}/>
            <Route path="EinzelwertungAB10m" element={<Ab10mEinzelwertung/>}/>

            <Route path="/AB10mk" element={<AB10mk/>}/>
            <Route path="SetzlistenAB10mk" element={<Ab10mkSetzliste/>}/>
            <Route path="EinzelwertungAB10mk" element={<Ab10mkEinzelwertung/>}/>

            <Route path="/AB10ma" element={<Ab10ma/>}/>
            <Route path="SetzlistenAB10ma" element={<Ab10mASetzliste/>}/>
            <Route path="EinzelwertungAB10ma" element={<Ab10mAEinzelwertung/>}/>

            <Route path="/Ab30m" element={<Ab30m/>}/>
            <Route path="SetzlistenAB30m" element={<Ab30mSetzliste/>}/>
            <Route path="EinzelwertungAB30m" element={<Ab30mEinzelwertung/>}/>


            <Route path="/Ab10m" element={<Ab10ma/>}>
                <Route path="unterelement2.1" element={<Ab10ma/>}/>
                <Route path="unterelement2.2" element={<Ab10ma/>}/>
            </Route>

            {props.loggedIn && (
                <Route path="/Verwaltung" element={<Verwaltung token={props.token}/>}/>
            )}
            {props.loggedIn && (
                <Route path="/Verwaltung/Stammdaten" element={<Stammdaten token={props.token}/>}/>
            )}
            {props.loggedIn && (
                <Route path="/Verwaltung/Saisondaten" element={<Saisondaten token={props.token}/>}/>
            )}
            {props.loggedIn && (
                <Route path="/Verwaltung/Wettkampf" element={<VerwaltungWettkampf token={props.token}/>}/>
            )}
            {props.loggedIn && (
                <Route path="/Konfiguration" element={<Bau token={props.token}/>}/>
            )}
            {props.loggedIn && (
                <Route path="/Konfiguration/Ergebnisse" element={<Ergebnisse token={props.token}/>}/>
            )}
            {props.loggedIn && (
                <Route path="/Konfiguration/Mannschaftsmeldung"
                       element={<Mannschaftsmeldung token={props.token}/>}/>
            )}
            {props.loggedIn && (
                <Route path="/Konfiguration/EigenerUser"
                       element={<EigenerUser token={props.token}/>}/>
            )}
            <Route path="/login" element={<Login onLogin={props.onLogin}/>}/>
        </Routes>
    </main>;
}